import React from 'react';
import InlineSVG from 'react-inlinesvg';

import assets from '../../../assets';

const svgStyle = {
  minWidth: 16,
};

type ItemIconProps = {
  isCustomer?: boolean;
};

const ItemIcon = ({ isCustomer }: ItemIconProps): JSX.Element | null => {
  if (isCustomer) {
    return (
      <InlineSVG
        data-testid="item-icon"
        src={assets.icons.customerEntry}
        style={svgStyle}
      />
    );
  }
  return (
    <InlineSVG
      data-testid="item-icon"
      src={assets.icons.group}
      style={svgStyle}
    />
  );
};

export default ItemIcon;
